import { createEnv } from "@t3-oss/env-core";
import z from "zod";

export const env = createEnv({
  server: {},
  client: {
    VITE_SERVER_URL: z.url(),
    VITE_GOOGLE_MAPS_API_KEY: z.string(),
    VITE_AG_GRID_KEY: z.string(),
  },
  clientPrefix: "VITE_",
  runtimeEnv: import.meta.env,
});
